<template>
<div class="chapter">
<div class="inner_page">
<a id="page_vii"></a>
<h2 class="fmtitle">Author’s Statement</h2>
<p class="noindent">Ten years ago, as I began the countdown to my retirement, I thought I would like to embark on a project that was very different from my long-term commitment to company accounts, stocks, shares, indices and increasingly arduous anti-money laundering regulations. That is not so say that my preceding decades had not been interesting, nor worthwhile, but enough was enough and I now craved mental stimulation of a very different kind.</p>
<p class="indent">History seemed a natural choice – real stories about real people – and after a number of false starts, I decided upon Jerusalem. My wife of thirty-seven years had been born in Bethlehem, where the Roman Catholic community is treated mostly with disdain by the majority Muslim population and with caution by the Israeli authorities, and I had visited nearby Jerusalem with my wife and children during the 1990s.</p>
<p class="indent">I was fascinated by Jerusalem’s Old City and why this tiny place was so important to so many of today’s religious groups – Jews, Muslims and a variety of Christians creeds such as Roman Catholics, Armenians and Greek Orthodox. It was not until I began my ‘Jerusalem project’ that I  realized how little I  knew and this enabled me to arrive at an inescapable conclusion: as a self-respecting pedant, I had to start at the very beginning.</p>
<p class="indent">In order to annotate to the depth that I felt would make the project worthwhile, I have concluded just before the well-documented subsequent periods, which others have chronicled. I hope that any readers of this book will enjoy the overall story of Jerusalem in antiquity, and perhaps even find it helpful as a volume that may be occasionally used for reference purposes.</p>
<p class="indent">I  would like to record the invaluable assistance of my daughter Alison, who, in spite of leading a very busy life, found time to read <a id="page_viii"></a>and re-read my drafts in order to ensure good English and clarity of expression. The maps and diagrams in this book are essentially the result of the conscientious endeavours of Ben Charles, to whom I am also very grateful.</p>
<p class="right">Alan J. Potter</p>
<p class="right1">September 2019</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Author.vue?21b4e70c